import { get } from 'lodash'

import { BarError } from 'classes/errors'
import { notifyError } from 'app_modules/notifications/actions'
import * as sessionSelectors from 'app_modules/session/selectors'
import accountsActionTypes from 'app_modules/accounts/constants'
import api from 'api'

// Actions

export const fetchLimitedMembersFailure = error => ({
  payload: error,
  type: accountsActionTypes.FETCH_LIMITED_MEMBERS_FAILURE,
})

export const fetchLimitedMembersRequest = pageIndex => ({
  payload: pageIndex,
  type: accountsActionTypes.FETCH_LIMITED_MEMBERS_REQUEST,
})

export const fetchLimitedMembersSuccess = response => ({
  payload: response,
  type: accountsActionTypes.FETCH_LIMITED_MEMBERS_SUCCESS,
})

// Thunks

export const fetchLimitedMembers = ({ pageIndex = 1, search, workshopFilter }, onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const state = getState()

    const accountId = sessionSelectors.accountId(state)

    dispatch(fetchLimitedMembersRequest(pageIndex))

    const handleResponse = response => {
      // TODO: Fix the endpoint schema, also review the invitation endpoint
      const fixedResponse = {
        ...response,
        account: get(response, 'profiles[0].account'),
        updateCounters: !search,
      }

      dispatch(fetchLimitedMembersSuccess(fixedResponse))

      if (onSuccess) {
        onSuccess(fixedResponse)
      }
    }

    const handleError = ({ error, isConnectionError }) => {
      dispatch(fetchLimitedMembersFailure(error))
      if (!isConnectionError) {
        dispatch(notifyError(new BarError({ ...error, label: 'getMyMembersError' })))
      }
      if (onError) {
        onError(error)
      }
    }

    return api.accounts.getLimitedMembers({ accountId, pageIndex, search, workshopFilter }, handleResponse, handleError)
  }

  thunk.type = accountsActionTypes.FETCH_LIMITED_MEMBERS

  return thunk
}

export default fetchLimitedMembers
